import { Injectable } from '@angular/core';
import { UserSessionService } from '../user-session/user-session.service';
import { WebservicesService } from '../webservices/webservices.service';

@Injectable({
  providedIn: 'root'
})
export class AccountSummaryService {
  private customer;

  constructor(
    private userSession: UserSessionService,
    private webservice: WebservicesService
    ) { 
      this.userSession.getCustomer().subscribe(
        (customer) => {
            this.customer = customer;
        }
    );

    }

  callGetAccountSummary(data: any) {
    let obj: any = {
        customer_id: this.customer.customerId,
        session_token: this.userSession.sessionToken,
        currency_code: data.currency_code,
        date_from: data.dateFrom,
        date_to: data.dateTo,
        pageno: data.pageno
    }

    return this.webservice.post('cashier/get-past-account-summary', obj);
}

  getCustomer() {
    return this.customer;
  }
}
